'use client';

import { CloseIcon } from '@insta-club/components';
import { cn } from '@insta-club/utilities';
import { useEffect } from 'react';
import { Drawer, type DialogProps } from 'vaul';

type Props = React.PropsWithChildren<DialogProps> & {
    title?: string;
    trigger?: React.ReactNode;
    contentClassName?: string;
    preventBackNavigation?: boolean;
};

const BottomSheet: React.FC<Props> = ({
    title,
    children,
    trigger,
    contentClassName,
    preventBackNavigation = true,
    ...props
}) => {
    const { open, onClose } = props;
    useEffect(() => {
        if (!open || !preventBackNavigation) return;

        const handlePopState = () => {
            onClose?.();
            history.pushState(null, '', location.href);
        };

        history.pushState(null, '', location.href);
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [open, onClose, preventBackNavigation]);

    return (
        <Drawer.Root {...props}>
            {!!trigger && <Drawer.Trigger asChild>{trigger}</Drawer.Trigger>}
            <Drawer.Portal>
                <Drawer.Overlay className='absolute inset-0 z-[60] bg-black/40' />
                <Drawer.Content
                    className={cn(
                        'absolute right-0 bottom-0 left-0 z-[60] h-fit rounded-t-xl bg-white px-6 pb-6 outline-none',
                        contentClassName
                    )}
                >
                    <div className='m-auto my-4 h-1.5 w-10 rounded-2xl bg-gray-200' />
                    <div className='mb-5 flex items-center gap-2'>
                        <Drawer.Title className='flex-1 truncate text-base font-bold text-gray-800'>
                            {title}
                        </Drawer.Title>
                        <Drawer.Close className='cursor-pointer text-sm font-normal text-gray-700'>
                            <CloseIcon />
                        </Drawer.Close>
                    </div>
                    {children}
                </Drawer.Content>
            </Drawer.Portal>
        </Drawer.Root>
    );
};

export default BottomSheet;

